'use client';

import { motion } from 'framer-motion';
import Button from '@/components/ui/Button';
import type { MissionModel } from '@/lib/mappers/missionMapper';

interface OurMissionSectionServerProps {
  initialData: MissionModel;
  dict: any;
}

const OurMissionSectionServer = ({ initialData, dict }: OurMissionSectionServerProps) => {
  return (
    <section 
      className="py-20"
      style={{ backgroundColor: initialData.layout.backgroundColor }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center rounded-3xl p-8"
          style={{
            border: `2px dashed ${initialData.layout.borderColor}`,
            backgroundColor: initialData.layout.backgroundColor
          }}
        >
          {/* Left Side - Image */}
          <motion.div 
            className="relative"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <motion.img 
                src={initialData.image.src}
                alt={initialData.image.alt}
                className="w-full h-full object-cover aspect-[4/3]"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              />
            </div>
          </motion.div>

          {/* Right Side - Content */}
          <motion.div 
            className="text-white"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p 
              className="text-sm font-semibold uppercase tracking-wide mb-2"
              style={{ 
                fontSize: initialData.typography.badge.fontSize,
                fontWeight: initialData.typography.badge.fontWeight,
                textTransform: initialData.typography.badge.textTransform as any,
                letterSpacing: initialData.typography.badge.letterSpacing,
                color: initialData.typography.badge.color
              }}
            >
              {initialData.badge}
            </p>
            
            <h2
              className="mb-6"
              style={{ 
                fontFamily: initialData.typography.title.fontFamily,
                fontSize: initialData.typography.title.fontSize,
                fontWeight: initialData.typography.title.fontWeight,
                lineHeight: initialData.typography.title.lineHeight,
                color: initialData.typography.title.color
              }}
            >
              {initialData.title}
            </h2>

            <p
              className="mb-8"
              style={{ 
                fontFamily: initialData.typography.subtitle.fontFamily,
                fontSize: initialData.typography.subtitle.fontSize,
                fontWeight: initialData.typography.subtitle.fontWeight,
                lineHeight: initialData.typography.subtitle.lineHeight,
                color: initialData.typography.subtitle.color
              }}
            >
              {initialData.subtitle}
            </p>
            
            <Button 
              variant={initialData.cta.variant as any}
              size={initialData.cta.size as any}
              className="rounded-lg"
              style={{
                backgroundColor: initialData.cta.style.backgroundColor,
                color: initialData.cta.style.color,
                borderRadius: initialData.cta.style.borderRadius
              }}
            >
              {initialData.cta.text}
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default OurMissionSectionServer;
